import { ReactNode } from "react";
import { IconButton as MuiIconButton, IconButtonProps as MuiIconButtonProps } from "@mui/material";
import { IconButtonSize, IconButtonTheme } from "./icon-button.constants";
import classnames from "classnames";
import styles from "./icon-button.styles.module.scss";

export type IconButtonProps = {
  children: ReactNode;
  theme?: `${IconButtonTheme}`;
  size?: `${IconButtonSize}`;
  ariaLabel?: string;
  isDisabled?: boolean;
  onClick?: MuiIconButtonProps["onClick"];
  rootClassName?: string;
  additionalProps?: Partial<MuiIconButtonProps>;
};

export const IconButtonComponent = ({
  children,
  theme = IconButtonTheme.LIGHT,
  size = IconButtonSize.DEFAULT,
  ariaLabel,
  isDisabled = false,
  onClick,
  rootClassName = "",
  additionalProps = {}
}: IconButtonProps) =>
  <MuiIconButton
    aria-label={ariaLabel}
    className={rootClassName}
    disabled={isDisabled}
    disableFocusRipple={true}
    onClick={onClick}
    disableRipple={theme === IconButtonTheme.GREY || theme === IconButtonTheme.LIGHT}
    size={{
      [IconButtonSize.SMALL]: "small",
      [IconButtonSize.DEFAULT]: "medium",
    }[size] as "small" | "medium"}
    classes={{
      root: classnames(
        styles.button,
        styles.buttonRoot,
        {
          [IconButtonTheme.LIGHT]: styles.themeLight,
          [IconButtonTheme.LIGHT_DESTRUCTIVE]: styles.themeLightDestructive,
          [IconButtonTheme.DARK]: styles.themeDark,
          [IconButtonTheme.GREY]: styles.themeGrey,
        }[theme],
      ),
      disabled: styles.buttonDisabled,
      sizeSmall: styles.sizeSmall,
      sizeMedium: styles.sizeDefault,
    }}
    TouchRippleProps={{
      classes: {
        root: styles.rippleRoot,
        ripple: styles.ripple,
      }
    }}
    {...additionalProps}
  >
    <span className={styles.iconContainer}>
      {children}
    </span>
  </MuiIconButton>;
